import React, { KeyboardEvent, useEffect, useRef, useState } from "react";

import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs, { Dayjs } from "dayjs";
import { Box, Popper } from "@mui/material";
import { StyleSettings } from "../../styles/StyleSettings";
import SnTextBox from "./SnTextBox";

interface SnDateRangeBoxProps {
  defaultValue?: string;
  onValueChanged?: (start: string, end: string) => void;
  format?: string;
  isReadOnly?: boolean;
  isRequired?: boolean;
  isEditable?: boolean;
  popupRef?: any;
  inputRef?: any;
  isSearchPanel?: boolean;
  onFocus?: (target: string) => void;
}

const SnPeriodTextBox = React.memo(
  ({
    defaultValue,
    onValueChanged,
    format,
    isReadOnly = false,
    isRequired,
    isEditable = true,
    popupRef,
    inputRef,
    isSearchPanel = false,
    onFocus,
  }: SnDateRangeBoxProps) => {
    const start: string = defaultValue ? defaultValue.split(",")[0].trim() : "";
    const end: string = defaultValue ? defaultValue.split(",")[1].trim() : "";
    const [startValue, setStartValue] = useState(start);
    const [endValue, setEndValue] = useState(end);
    const [borderWidth, setBorderWidth] = useState("1px");
    const [backgroundColor, setBackgroundColor] = useState("#F1F1F1");

    const fetchDefaultValue = async () => {
      try {
        if (defaultValue !== undefined) {
          const start: string = defaultValue.split(",")[0].trim();
          const end: string = defaultValue.split(",")[1].trim();
          setStartValue(start);
          setEndValue(end);
        }
      } catch (error: any) {}
    };

    const fetchIsRequired = async () => {
      try {
        if (isRequired) setBorderWidth("2px");
        else setBorderWidth("1px");
      } catch (error: any) {}
    };

    const fetchIsEditable = async () => {
      try {
        if (isEditable) setBackgroundColor("white");
        else setBackgroundColor("#F1F1F1");
      } catch (error: any) {}
    };

    useEffect(() => {
      fetchDefaultValue();
    }, [defaultValue]);

    useEffect(() => {
      fetchIsRequired();
    }, [isRequired]);

    useEffect(() => {
      fetchIsEditable();
    }, [isEditable]);

    return (
      <div style={{ display: "flex", alignItems: "center", gap: "15px" }}>
        <div style={{ width: "100%" }}>
          <SnTextBox
            defaultValue={startValue}
            onValueChanged={(data: string) => {
              if (onValueChanged) {
                onValueChanged(data, endValue);
              }
            }}
            format={format}
            isRequired={isRequired}
            isReadOnly={isReadOnly}
            isEditable={isEditable}
          />
        </div>
        <Box> – </Box>
        <div style={{ width: "100%" }}>
          <SnTextBox
            defaultValue={endValue}
            onValueChanged={(data: string) => {
              if (onValueChanged) {
                onValueChanged(startValue, data);
              }
            }}
            format={format}
            isRequired={isRequired}
            isReadOnly={isReadOnly}
            isEditable={isEditable}
          />
        </div>
      </div>
    );
  }
);

export default SnPeriodTextBox;
